import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { MatLabel } from '@angular/material/form-field';
import { ApexOptions, NgApexchartsModule } from 'ng-apexcharts';

@Component({
    selector: 'app-donut-chart',
    templateUrl: './donut-chart.component.html',
    styleUrls: ['./donut-chart.component.scss'],
    imports: [
        MatLabel,
        NgApexchartsModule
    ],
    standalone: true
})
export class DonutChartComponent {
    @Input() width: number = 300; // Default width
    @Input() height: number = 300; // Default height

    @Input('data') set setData(data: number[]) {
        if (data) {
            // If you do not map the values to numbers they get loaded as strings when passed via the input
            // and the chart does not work.

            if(data[0] != 0  && data[1] != 0 ){
                this.percentage = +((data[0] / data[1]) * 100).toFixed(0);
            } else{
                this.percentage = 0;
            }

            this.chartOptions.series = [this.percentage, 100 - this.percentage];
        }
    }

    constructor(private cdr: ChangeDetectorRef) {
    }

    @Input('colors') set setColors(colors: string[]) {
        this.chartOptions.colors = colors.reverse();
    }

    public percentage: number = 0;
    public chartOptions: ApexOptions = {
        chart: {
            animations: {
                speed: 400,
                animateGradually: {
                    enabled: false,
                },
            },
            fontFamily: 'inherit',
            foreColor: 'inherit',
            width: '130px',
            height: '130px',
            type: 'donut',
            sparkline: {
                enabled: true,
            },
        },
        plotOptions: {
            pie: {
                customScale: 1,
                expandOnClick: false,
                donut: {
                    size: '70%',
                },
            },
        },
        legend: {
            show: false,
        },
        dataLabels: {
            enabled: false,
        },
        tooltip: {
            enabled: false
        },
        states: {
            hover: {
                filter: {
                    type: 'none',
                },
            },
            active: {
                filter: {
                    type: 'none',
                },
            },
        },
    };
}
